
const XaData = () => {
    return [
        {
            "Index": 1,
            "Name": "Phường An Bình",
            "UnsignedName": "PHUONGANBINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường An Bình&code=H20.110",
            "Address": "Phường An Bình"
        },
        {
            "Index": 2,
            "Name": "Phường Bình Xuân",
            "UnsignedName": "PHUONGBINHXUAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Bình Xuân&code=H20.125",
            "Address": "Phường Bình Xuân"
        },
        {
            "Index": 3,
            "Name": "Phường Cai Lậy",
            "UnsignedName": "PHUONGCAILAY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Cai Lậy&code=H20.128",
            "Address": "Phường Cai Lậy"
        },
        {
            "Index": 4,
            "Name": "Phường Cao Lãnh",
            "UnsignedName": "PHUONGCAOLANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Cao Lãnh&code=H20.113",
            "Address": "Số 03, đường 30/4, phường Cao Lãnh, tỉnh Đồng Tháp"
        },
        {
            "Index": 5,
            "Name": "Phường Đạo Thạnh",
            "UnsignedName": "PHUONGDAOTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Đạo Thạnh&code=H20.118",
            "Address": "Phường Đạo Thạnh"
        },
        {
            "Index": 6,
            "Name": "Phường Gò Công",
            "UnsignedName": "PHUONGGOCONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Gò Công&code=H20.122",
            "Address": "Đường Võ Duy Linh, Khu phố 10, phường Gò Công, tỉnh Đồng Tháp"
        },
        {
            "Index": 7,
            "Name": "Phường Hồng Ngự",
            "UnsignedName": "PHUONGHONGNGU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Hồng Ngự&code=H20.111",
            "Address": "Số 100, đường Trương Định, khóm 1, Phường Hồng Ngự, tỉnh Đồng Tháp"
        },
        {
            "Index": 8,
            "Name": "Phường Long Thuận",
            "UnsignedName": "PHUONGLONGTHUAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Long Thuận&code=H20.123",
            "Address": "Phường Long Thuận"
        },
        {
            "Index": 9,
            "Name": "Phường Mỹ Ngãi",
            "UnsignedName": "PHUONGMYNGAI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Mỹ Ngãi&code=H20.114",
            "Address": "Số 324, đường Mai Văn Khải, phường Mỹ Ngãi, tỉnh Đồng Tháp"
        },
        {
            "Index": 10,
            "Name": "Phường Mỹ Phong",
            "UnsignedName": "PHUONGMYPHONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Mỹ Phong&code=H20.119",
            "Address": "Số 12, đường Âu Dương Lân, khu phố 1, Phường Mỹ Phong, tỉnh Đồng Tháp"
        },
        {
            "Index": 11,
            "Name": "Phường Mỹ Phước Tây",
            "UnsignedName": "PHUONGMYPHUOCTAY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Mỹ Phước Tây&code=H20.126",
            "Address": "Phường Mỹ Phước Tây"
        },
        {
            "Index": 12,
            "Name": "Phường Mỹ Tho",
            "UnsignedName": "PHUONGMYTHO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Mỹ Tho&code=H20.117",
            "Address": "Phường Mỹ Tho"
        },
        {
            "Index": 13,
            "Name": "Phường Mỹ Trà",
            "UnsignedName": "PHUONGMYTRA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Mỹ Trà&code=H20.115",
            "Address": "Số 397, đường Tôn Đức Thắng, khóm Mỹ Trung, phường Mỹ Trà, tỉnh Đồng Tháp"
        },
        {
            "Index": 14,
            "Name": "Phường Nhị Quý",
            "UnsignedName": "PHUONGNHIQUY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Nhị Quý&code=H20.129",
            "Address": "Phường Nhị Quý, tỉnh Đồng Tháp"
        },
        {
            "Index": 15,
            "Name": "Phường Sa Đéc",
            "UnsignedName": "PHUONGSADEC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Sa Đéc&code=H20.116",
            "Address": "Phường Sa Đéc"
        },
        {
            "Index": 16,
            "Name": "Phường Sơn Qui",
            "UnsignedName": "PHUONGSONQUI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Sơn Qui&code=H20.124",
            "Address": "Phường Sơn Qui"
        },
        {
            "Index": 17,
            "Name": "Phường Thanh Hòa",
            "UnsignedName": "PHUONGTHANHHOA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Thanh Hòa&code=H20.127",
            "Address": "Phường Thanh Hòa"
        },
        {
            "Index": 18,
            "Name": "Phường Thới Sơn",
            "UnsignedName": "PHUONGTHOISON",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Thới Sơn&code=H20.120",
            "Address": "329/2 Nguyễn Thị Thập, phường Thới Sơn, tỉnh Đồng Tháp"
        },
        {
            "Index": 19,
            "Name": "Phường Thường Lạc",
            "UnsignedName": "PHUONGTHUONGLAC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Thường Lạc&code=H20.112",
            "Address": "841, Thoại Ngọc Hầu, phường Thường Lạc, tỉnh Đồng Tháp"
        },
        {
            "Index": 20,
            "Name": "Phường Trung An",
            "UnsignedName": "PHUONGTRUNGAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Phường Trung An&code=H20.121",
            "Address": "Phường Trung An, tỉnh Đồng Tháp"
        },
        {
            "Index": 21,
            "Name": "Xã An Hữu",
            "UnsignedName": "XAANHUU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã An Hữu&code=H20.170",
            "Address": "Xã An Hữu, tỉnh Đồng Tháp"
        },
        {
            "Index": 22,
            "Name": "Xã An Hòa",
            "UnsignedName": "XAANHOA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã An Hòa&code=H20.137",
            "Address": "Xã An Hòa, tỉnh Đồng Tháp"
        },
        {
            "Index": 23,
            "Name": "Xã An Long",
            "UnsignedName": "XAANLONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã An Long&code=H20.142",
            "Address": "Quốc lộ 30, ấp 2, xã An Long, tỉnh Đồng Tháp"
        },
        {
            "Index": 24,
            "Name": "Xã An Phước",
            "UnsignedName": "XAANPHUOC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã An Phước&code=H20.133",
            "Address": "Ấp Hoàng Việt, xã An Phước, tỉnh Đồng Tháp"
        },
        {
            "Index": 25,
            "Name": "Xã An Thạnh Thủy",
            "UnsignedName": "XAANTHAMHTHUY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã An Thạnh Thủy&code=H20.198",
            "Address": "Ấp Bình Thọ Trung, xã An Thạnh Thủy, tỉnh Đồng Tháp"
        },
        {
            "Index": 26,
            "Name": "Xã Ba Sao",
            "UnsignedName": "XABASAO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Ba Sao&code=H20.154",
            "Address": "Xã Ba Sao"
        },
        {
            "Index": 27,
            "Name": "Xã Bình Hàng Trung",
            "UnsignedName": "XABINHHANGTRUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Bình Hàng Trung&code=H20.156",
            "Address": "Xã Bình Hàng Trung"
        },
        {
            "Index": 28,
            "Name": "Xã Bình Ninh",
            "UnsignedName": "XABINHMINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Bình Ninh&code=H20.199",
            "Address": "Xã Bình Ninh"
        },
        {
            "Index": 29,
            "Name": "Xã Bình Phú",
            "UnsignedName": "XABINHPHU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Bình Phú&code=H20.177",
            "Address": "Xã Bình Phú"
        },
        {
            "Index": 30,
            "Name": "Xã Bình Thành",
            "UnsignedName": "XABINHTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Bình Thành&code=H20.145",
            "Address": "Xã Bình Thành"
        },
        {
            "Index": 31,
            "Name": "Xã Bình Trưng",
            "UnsignedName": "XABINHTRUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Bình Trưng&code=H20.193",
            "Address": "Ấp Bình Trưng, xã Bình Trưng, tỉnh Đồng Tháp"
        },
        {
            "Index": 32,
            "Name": "Xã Cái Bè",
            "UnsignedName": "XACAIBE",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Cái Bè&code=H20.176",
            "Address": "Xã Cái Bè"
        },
        {
            "Index": 33,
            "Name": "Xã Châu Thành",
            "UnsignedName": "XACHAUTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Châu Thành&code=H20.188",
            "Address": "Xã Châu Thành"
        },
        {
            "Index": 34,
            "Name": "Xã Chợ Gạo",
            "UnsignedName": "XACHOGAO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Chợ Gạo&code=H20.197",
            "Address": "Xã Chợ Gạo"
        },
        {
            "Index": 35,
            "Name": "Xã Đốc Binh Kiều",
            "UnsignedName": "XADOCBINHKIEU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Đốc Binh Kiều&code=H20.150",
            "Address": "Xã Đốc Binh Kiều"
        },
        {
            "Index": 36,
            "Name": "Xã Đông Sơn",
            "UnsignedName": "XADONGSON",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Đồng Sơn&code=H20.201",
            "Address": "Xã Đông Sơn"
        },
        {
            "Index": 37,
            "Name": "Xã Gia Thuận",
            "UnsignedName": "XAGIATHUAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Gia Thuận&code=H20.209",
            "Address": "ĐT 871, xã Gia Thuận, tỉnh Đồng Tháp"
        },
        {
            "Index": 38,
            "Name": "Xã Gò Công Đông",
            "UnsignedName": "XAGOCONGDONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Gò Công Đông&code=H20.205",
            "Address": "Xã Gò Công Đông"
        },
        {
            "Index": 39,
            "Name": "Xã Hậu Mỹ",
            "UnsignedName": "XAHAUMY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Hậu Mỹ&code=H20.174",
            "Address": "Xã Hậu Mỹ"
        },
        {
            "Index": 40,
            "Name": "Xã Hiệp Đức",
            "UnsignedName": "XAHIEPDUC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Hiệp Đức&code=H20.178",
            "Address": "Xã Hiệp Đức"
        },
        {
            "Index": 41,
            "Name": "Xã Hòa Long",
            "UnsignedName": "XAHOALONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Hòa Long&code=H20.162",
            "Address": "Quốc lộ 80, ấp 1, xã Hòa Long, tỉnh Đồng Tháp"
        },
        {
            "Index": 42,
            "Name": "Xã Hội Cư",
            "UnsignedName": "XAHOCU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Hội Cư&code=H20.175",
            "Address": "Xã Hội Cư"
        },
        {
            "Index": 43,
            "Name": "Xã Hưng Thạnh",
            "UnsignedName": "XAHUNGTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Hưng Thạnh&code=H20.186",
            "Address": "Xã Hưng Thạnh"
        },
        {
            "Index": 44,
            "Name": "Xã Kim Sơn",
            "UnsignedName": "XAKIMSON",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Kim Sơn&code=H20.192",
            "Address": "Xã Kim Sơn"
        },
        {
            "Index": 45,
            "Name": "Xã Lai Vung",
            "UnsignedName": "XALAIVUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Lai Vung&code=H20.161",
            "Address": "Ấp Tân Lộc, xã Lai Vung, tỉnh Đồng Tháp"
        },
        {
            "Index": 46,
            "Name": "Xã Lấp Vò",
            "UnsignedName": "XALAPVO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Lấp Vò&code=H20.160",
            "Address": "Xã Lấp Vò"
        },
        {
            "Index": 47,
            "Name": "Xã Long Bình",
            "UnsignedName": "XALONGBINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Bình&code=H20.203",
            "Address": "Xã Long Bình"
        },
        {
            "Index": 48,
            "Name": "Xã Long Định",
            "UnsignedName": "XALONGDINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Định&code=H20.190",
            "Address": "Xã Long Định"
        },
        {
            "Index": 49,
            "Name": "Xã Long Hưng",
            "UnsignedName": "XALONGHUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Hưng&code=H20.189",
            "Address": "Xã Long Hưng"
        },
        {
            "Index": 50,
            "Name": "Xã Long Khánh",
            "UnsignedName": "XALONGKHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Khánh&code=H20.135",
            "Address": "Xã Long Khánh"
        },
        {
            "Index": 51,
            "Name": "Xã Long Phú Thuận",
            "UnsignedName": "XALONGPHUTHUAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Phú Thuận&code=H20.136",
            "Address": "Xã Long Phú Thuận"
        },
        {
            "Index": 52,
            "Name": "Xã Long Tiên",
            "UnsignedName": "XALONGTIEN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Long Tiên&code=H20.180",
            "Address": "Ấp 01, Xã Long Tiên, tỉnh Đồng Tháp"
        },
        {
            "Index": 53,
            "Name": "Xã Lương Hòa Lạc",
            "UnsignedName": "XALUONGHOALAC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Lương Hòa Lạc&code=H20.195",
            "Address": "Xã Lương Hòa Lạc"
        },
        {
            "Index": 54,
            "Name": "Xã Mỹ An Hưng",
            "UnsignedName": "XAMYANHUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ An Hưng&code=H20.158",
            "Address": "Xã Mỹ An Hưng"
        },
        {
            "Index": 55,
            "Name": "Xã Mỹ Đức Tây",
            "UnsignedName": "XAMYDUCTAY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Đức Tây&code=H20.172",
            "Address": "Xã Mỹ Đức Tây"
        },
        {
            "Index": 56,
            "Name": "Xã Mỹ Hiệp",
            "UnsignedName": "XAMYHIỆP",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Hiệp&code=H20.157",
            "Address": "Xã Mỹ Hiệp"
        },
        {
            "Index": 57,
            "Name": "Xã Mỹ Lợi",
            "UnsignedName": "XAMYLOI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Lợi&code=H20.171",
            "Address": "Xã Mỹ Lợi"
        },
        {
            "Index": 58,
            "Name": "Xã Mỹ Quí",
            "UnsignedName": "XAMYQUI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Quí&code=H20.149",
            "Address": "Ấp Mỹ Phước 1, xã Mỹ Quí, tỉnh Đồng Tháp"
        },
        {
            "Index": 59,
            "Name": "Xã Mỹ Thành",
            "UnsignedName": "XAMYTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Thành&code=H20.181",
            "Address": "Xã Mỹ Thành"
        },
        {
            "Index": 60,
            "Name": "Xã Mỹ Thiện",
            "UnsignedName": "XAMYTHIEN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Thiện&code=H20.173",
            "Address": "Xã Mỹ Thiện"
        },
        {
            "Index": 61,
            "Name": "Xã Mỹ Thọ",
            "UnsignedName": "XAMYTHO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Thọ&code=H20.155",
            "Address": "Xã Mỹ Thọ"
        },
        {
            "Index": 62,
            "Name": "Xã Mỹ Tịnh An",
            "UnsignedName": "XAMYTINHAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Mỹ Tịnh An&code=H20.194",
            "Address": "Xã Mỹ Tịnh An"
        },
        {
            "Index": 63,
            "Name": "Xã Ngũ Hiệp",
            "UnsignedName": "XANGUHIỆP",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Ngũ Hiệp&code=H20.179",
            "Address": "Xã Ngũ Hiệp"
        },
        {
            "Index": 64,
            "Name": "Xã Phong Hòa",
            "UnsignedName": "XAPHONGHOA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phong Hòa&code=H20.163",
            "Address": "Ấp Hòa Tân, xã Phong Hòa, tỉnh Đồng Tháp"
        },
        {
            "Index": 65,
            "Name": "Xã Phong Mỹ",
            "UnsignedName": "XAPHONGMY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phong Mỹ&code=H20.153",
            "Address": "Xã Phong Mỹ"
        },
        {
            "Index": 66,
            "Name": "Xã Phú Cường",
            "UnsignedName": "XAPHUCUONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phú Cường&code=H20.141",
            "Address": "Đường Võ Văn Kiệt, ấp A, xã Phú Cường, tỉnh Đồng Tháp"
        },
        {
            "Index": 67,
            "Name": "Xã Phú Hựu",
            "UnsignedName": "XAPHUHUYEU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phú Hựu&code=H20.165",
            "Address": "Số 80, Quốc lộ 80, ấp Phú Mỹ, xã Phú Hựu, tỉnh Đồng Tháp"
        },
        {
            "Index": 68,
            "Name": "Xã Phú Thành",
            "UnsignedName": "XAPHUTHANH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phú Thành&code=H20.202",
            "Address": "Ấp Bình Hưng, xã Phú Thành, tỉnh Đồng Tháp"
        },
        {
            "Index": 69,
            "Name": "Xã Phú Thọ",
            "UnsignedName": "XAPHUTHO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phú Thọ&code=H20.139",
            "Address": "Ấp Long Thành, xã Phú Thọ, tỉnh Đồng Tháp"
        },
        {
            "Index": 70,
            "Name": "Xã Phương Thịnh",
            "UnsignedName": "XAPHUONGTHINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Phương Thịnh&code=H20.152",
            "Address": "Ấp 3, xã Phương Thịnh, tỉnh Đồng Tháp"
        },
        {
            "Index": 71,
            "Name": "Xã Tam Nông",
            "UnsignedName": "XATAMNONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tam Nông&code=H20.138",
            "Address": "Xã Tam Nông"
        },
        {
            "Index": 72,
            "Name": "Xã Tân Điền",
            "UnsignedName": "XATANDIEN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Điền&code=H20.206",
            "Address": "Ấp Trung, xã Tân Điền, tỉnh Đồng Tháp"
        },
        {
            "Index": 73,
            "Name": "Xã Tân Đông",
            "UnsignedName": "XATANDONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Đông&code=H20.208",
            "Address": "Xã Tân Đông"
        },
        {
            "Index": 74,
            "Name": "Xã Tân Dương",
            "UnsignedName": "XATANDUONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Dương&code=H20.164",
            "Address": "Xã Tân Dương"
        },
        {
            "Index": 75,
            "Name": "Xã Tân Hòa",
            "UnsignedName": "XATANHOA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Hòa&code=H20.207",
            "Address": "Xã Tân Hòa"
        },
        {
            "Index": 76,
            "Name": "Xã Tân Hộ Cơ",
            "UnsignedName": "XATANHOCU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Hộ Cơ&code=H20.132",
            "Address": "Xã Tân Hộ Cơ"
        },
        {
            "Index": 77,
            "Name": "Xã Tân Hồng",
            "UnsignedName": "XATANHONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Hồng&code=H20.130",
            "Address": "Số 323, đường Nguyễn Huệ, ấp 3, xã Tân Hồng, tỉnh Đồng Tháp"
        },
        {
            "Index": 78,
            "Name": "Xã Tân Hương",
            "UnsignedName": "XATANHUONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Hương&code=H20.187",
            "Address": "Xã Tân Hương"
        },
        {
            "Index": 79,
            "Name": "Xã Tân Khánh Trung",
            "UnsignedName": "XATANKHANHTRUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Khánh Trung&code=H20.159",
            "Address": "Ấp Hưng Mỹ Tây, xã Tân Khánh Trung, tỉnh Đồng Tháp"
        },
        {
            "Index": 80,
            "Name": "Xã Tân Long",
            "UnsignedName": "XATANLONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Long&code=H20.146",
            "Address": "Xã Tân Long"
        },
        {
            "Index": 81,
            "Name": "Xã Tân Nhuận Đông",
            "UnsignedName": "XATANNHUANDONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Nhuận Đông&code=H20.166",
            "Address": "ĐT 854, ấp Tân Lập, xã Tân Nhuận Đông, tỉnh Đồng Tháp"
        },
        {
            "Index": 82,
            "Name": "Xã Tân Phú",
            "UnsignedName": "XATANPHU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phú&code=H20.168",
            "Address": "Xã Tân Phú"
        },
        {
            "Index": 83,
            "Name": "Xã Tân Phú Đông",
            "UnsignedName": "XATANPHUDONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phú Đông&code=H20.211",
            "Address": "Ấp Bà Lắm, Xã Tân Phú Đông, tỉnh Đồng Tháp"
        },
        {
            "Index": 84,
            "Name": "Xã Tân Phú Trung",
            "UnsignedName": "XATANPHUTRUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phú Trung&code=H20.167",
            "Address": "Xã Tân Phú Trung"
        },
        {
            "Index": 85,
            "Name": "Xã Tân Phước 1",
            "UnsignedName": "XATANPHUOC1",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phước 1&code=H20.183",
            "Address": "Xã Tân Phước 1, tỉnh Đồng Tháp"
        },
        {
            "Index": 86,
            "Name": "Xã Tân Phước 2",
            "UnsignedName": "XATANPHUOC2",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phước 2&code=H20.184",
            "Address": "Ấp 4, Xã Tân Phước 2, tỉnh Đồng Tháp"
        },
        {
            "Index": 87,
            "Name": "Xã Tân Phước 3",
            "UnsignedName": "XATANPHUOC3",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Phước 3&code=H20.185",
            "Address": "Xã Tân Phước 3, tỉnh Đồng Tháp"
        },
        {
            "Index": 88,
            "Name": "Xã Tân Thành",
            "UnsignedName": "XATANTHAMH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Thành&code=H20.131",
            "Address": "Ấp Thi Sơn, xã Tân Thành, tỉnh Đồng Tháp"
        },
        {
            "Index": 89,
            "Name": "Xã Tân Thạnh",
            "UnsignedName": "XATANTHAMH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Thạnh&code=H20.144",
            "Address": "Xã Tân Thạnh"
        },
        {
            "Index": 90,
            "Name": "Xã Tân Thới",
            "UnsignedName": "XATANTHOI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Thới&code=H20.210",
            "Address": "Xã Tân Thới"
        },
        {
            "Index": 91,
            "Name": "Xã Tân Thuận Bình",
            "UnsignedName": "XATANTHUANBINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tân Thuận Bình&code=H20.196",
            "Address": "Xã Tân Thuận Bình"
        },
        {
            "Index": 92,
            "Name": "Xã Thạnh Phú",
            "UnsignedName": "XATHANHPHU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Thạnh Phú&code=H20.182",
            "Address": "Xã Thạnh Phú"
        },
        {
            "Index": 93,
            "Name": "Xã Thanh Bình",
            "UnsignedName": "XATHANHBINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Thanh Bình&code=H20.143",
            "Address": "Đường Lê Văn Nhung, ấp Tân Đông B, xã Thanh Bình, tỉnh Đồng Tháp"
        },
        {
            "Index": 94,
            "Name": "Xã Thanh Hưng",
            "UnsignedName": "XATHANHHUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Thanh Hưng&code=H20.169",
            "Address": "Ấp 1, xã Thanh Hưng, tỉnh Đồng Tháp"
        },
        {
            "Index": 95,
            "Name": "Xã Thanh Mỹ",
            "UnsignedName": "XATHANHMY",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Thanh Mỹ&code=H20.148",
            "Address": "Xã Thanh Mỹ"
        },
        {
            "Index": 96,
            "Name": "Xã Tháp Mười",
            "UnsignedName": "XATHAPMUOI",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tháp Mười&code=H20.147",
            "Address": "Xã Tháp Mười"
        },
        {
            "Index": 97,
            "Name": "Xã Thường Phước",
            "UnsignedName": "XATHUONGPHUOC",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Thường Phước&code=H20.134",
            "Address": "Ấp Thường Thới, xã Thường Phước, tỉnh Đồng Tháp"
        },
        {
            "Index": 98,
            "Name": "Xã Tràm Chim",
            "UnsignedName": "XATRAMCHIM",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Tràm Chim&code=H20.140",
            "Address": "Đường Võ Văn Kiệt, xã Tràm Chim, tỉnh Đồng Tháp"
        },
        {
            "Index": 99,
            "Name": "Xã Trường Xuân",
            "UnsignedName": "XATRUONGXUAN",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Trường Xuân&code=H20.151",
            "Address": "Xã Trường Xuân"
        },
        {
            "Index": 100,
            "Name": "Xã Vĩnh Bình",
            "UnsignedName": "XAVINHBINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Vĩnh Bình&code=H20.200",
            "Address": "Xã Vĩnh Bình"
        },
        {
            "Index": 101,
            "Name": "Xã Vĩnh Hựu",
            "UnsignedName": "XAVINHHYEU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Vĩnh Hựu&code=H20.204",
            "Address": "Ấp Thới An A, xã Vĩnh Hựu, tỉnh Đồng Tháp"
        },
        {
            "Index": 102,
            "Name": "Xã Vĩnh Kim",
            "UnsignedName": "XAVINHKIM",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Xã Vĩnh Kim&code=H20.191",
            "Address": "Ấp Vĩnh Thạnh, xã Vĩnh Kim, tỉnh Đồng Tháp"
        }
    ]
}

const SoBanNganhData = () => {
    return [
        {
            "Name": "Ban An toàn giao thông tỉnh",
            "UnsignedName": "BANANTOANGIAOTHONGTINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Ban%20An%20to%C3%A0n%20giao%20th%C3%B4ng%20t%E1%BB%89nh&code=H20.34",
            "Address": "Số 05, Hùng Vương, phường Mỹ Tho, Tỉnh Đồng Tháp"
        },
        // {
        //     "Name": "Ban Chỉ đạo ứng phó với Biến đổi khí hậu Phòng, chống thiên tai và Tìm kiếm cứu nạn tỉnh Đồng Tháp",
        //     "UnsignedName": "BANCHIDAOUNGPHOIVOIBIENDOIKHIHAUPHONGCHONGTHIENTAIVATIMKIEMCUUNAN",
        //     "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Ban%20Ch%E1%BB%89%20%C4%91%E1%BA%A1o%20%E1%BB%A9ng%20ph%C3%B3%20v%E1%BB%9Bi%20Bi%E1%BA%BFn%20%C4%91%E1%BB%95i%20kh%C3%AD%20h%E1%BA%ADu%20Ph%C3%B2ng%2C%20ch%E1%BB%91ng%20thi%C3%AAn%20tai%20v%C3%A0%20T%C3%ACm%20ki%E1%BA%BFm%20c%E1%BB%A9u%20n%E1%BA%A1n%20t%E1%BB%89nh%20%C4%90%E1%BB%93ng%20Th%C3%A1p&code=H20.41",
        //     "Address": "Số 05, Hùng Vương, Phường Mỹ Tho, Tỉnh Đồng Tháp"
        // },
        {
            "Name": "Ban Quản lý dự án tỉnh Đồng Tháp",
            "UnsignedName": "BANQUANLYDUANTINHDONGTHAP",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Ban%20Qu%E1%BA%A3n%20l%C3%BD%20d%E1%BB%B1%20%C3%A1n%20t%E1%BB%89nh%20%C4%90%E1%BB%93ng%20Th%C3%A1p&code=H20.43",
            "Address": "Số 10, đường Lê Thị Riêng, phường Cao Lãnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Ban Quản lý Khu Kinh Tế",
            "UnsignedName": "BQLKHUKINHTE",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Ban%20Qu%E1%BA%A3n%20l%C3%BD%20khu%20Kinh%20t%E1%BA%BF&code=H20.19",
            "Address": "Số 3 Lê Lợi, phường Mỹ Tho, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Công Thương",
            "UnsignedName": "SOCONGTHUONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20C%C3%B4ng%20Th%C6%B0%C6%A1ng&code=H20.3",
            "Address": "Số 387, Hùng Vương, phường Đạo Thạnh, Tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Giáo Dục và Đào Tạo",
            "UnsignedName": "SOGIAODUC&DAOTAO",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20Gi%C3%A1o%20d%E1%BB%A5c%20v%C3%A0%20%C4%90%C3%A0o%20t%E1%BA%A1o&code=H20.4",
            "Address": "Số 397 đường Hùng Vương, phường Đạo Thạnh,Tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Khoa Học và Công Nghệ",
            "UnsignedName": "SOKHOAHOC&CONGNGHE",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20Khoa%20h%E1%BB%8Dc%20v%C3%A0%20C%C3%B4ng%20ngh%E1%BB%87&code=H20.7",
            "Address": "Số 383 - 385 đường Hùng Vương, phường Đạo Thạnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Nông Nghiệp và Môi Trường",
            "UnsignedName": "SONONGNGHIEP&MOITRUONG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20N%C3%B4ng%20nghi%E1%BB%87p%20v%C3%A0%20M%C3%B4i%20tr%C6%B0%E1%BB%9Dng&code=H20.42",
            "Address": "Khu phố Trung Lương, phường Trung An, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Nội Vụ",
            "UnsignedName": "SONOIVU",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20N%E1%BB%99i%20v%E1%BB%A5&code=H20.10",
            "Address": "Số 375 - 379, Hùng Vương, phường Đạo Thạnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Tài Chính",
            "UnsignedName": "SOTAICHINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20T%C3%A0i%20ch%C3%ADnh&code=H20.12",
            "Address": "Số 05, Hùng Vương, phường Mỹ Tho, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Tư Pháp",
            "UnsignedName": "SOTUPHAP",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20T%C6%B0%20ph%C3%A1p&code=H20.15",
            "Address": "Số 361, Hùng Vương, phường Đạo Thạnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Văn Hoá, Thể Thao và Du Lịch",
            "UnsignedName": "SOVANHOATHETHAODULICH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20V%C4%83n%20ho%C3%A1%2C%20Th%E1%BB%83%20thao%20v%C3%A0%20Du%20l%E1%BB%8Bch&code=H20.16",
            "Address": "Số 399, Hùng Vương, phường Đạo Thạnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Xây Dựng",
            "UnsignedName": "SOXAYDUNG",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20X%C3%A2y%20d%E1%BB%B1ng&code=H20.17",
            "Address": "Số 56, Hùng Vương, phường Mỹ Tho, tỉnh Đồng Tháp"
        },
        {
            "Name": "Sở Y Tế",
            "UnsignedName": "SOYTE",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=S%E1%BB%9F%20Y%20t%E1%BA%BF&code=H20.18",
            "Address": "Số 373, Hùng Vương, phường Đạo Thạnh, tỉnh Đồng Tháp"
        },
        {
            "Name": "Thanh tra tỉnh",
            "UnsignedName": "THANHTRA",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=Thanh%20tra%20T%E1%BB%89nh&code=H20.2",
            "Address": "số 04 – 06 đường Lê Lợi, phường Mỹ Tho, tỉnh Đồng Tháp"
        },
        {
            "Name": "Văn phòng Uỷ ban nhân dân tỉnh",
            "UnsignedName": "VANPHONGUYBANNHANDANTINH",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=V%C4%83n%20ph%C3%B2ng%20U%E1%BB%B7%20ban%20nh%C3%A2n%20d%C3%A2n%20t%E1%BB%89nh&code=H20.1",
            "Address": "Số 23, đường 30/4, phường Mỹ Tho, tỉnh Đồng Tháp"
        },
    ]
}




const UBNDData = () => {
    return [
        {
            "Name": "UBND Tỉnh Đồng Tháp",
            "UnsignedName": "UBNDTINHDONGTHAP",
            "URL": "https://lichcongtac.dongthap.gov.vn/vi/public-schedule-view?name=%E1%BB%A6y%20ban%20nh%C3%A2n%20d%C3%A2n%20t%E1%BB%89nh%20%C4%90%E1%BB%93ng%20Th%C3%A1p&code=H20",
            "Address": "Số 23, đường 30/4, phường Mỹ Tho, tỉnh Đồng Tháp"
        }
    ]
}


export const Data = {
    XaData, UBNDData , SoBanNganhData
}
